module.exports = __webpack_public_path__ + "img/card_bg1.ab46a585.png";